
//JS From Biscuits to show Eco Label < Code from Biscuits
document.addEventListener('DOMContentLoaded', function() {
  let wrapper = document.querySelector('.biscuits-bundle-custom-details-wrapper');
  if (!wrapper){
    return;
  }
  let form = document.querySelector('.biscuits-bundle-form');
  let cards = form.querySelectorAll('.biscuits-bundle-item-card');
  cards.forEach(function(card){
    let productId = card.dataset.biscuitsCardId;
    if (card.querySelector('biscuits-bundle-variant')){
    
      let checkbox = card.querySelector('.biscuits-bundle-item-checkbox');
      if (checkbox ){
        const idList = checkbox.id.split('-');
        productId = idList[idList.length - 1];
      }
    }
    else if (card.querySelector('biscuits-bundle-product')){
      let productId = card.dataset.biscuitsCardId;
    }
    let extraDetails = wrapper.querySelector(`.biscuits-bundle-custom-details[data-biscuits-product-id="${productId}"]`);
    if (extraDetails){
      extraDetails.classList.remove('biscuits--hidden');
      card.querySelector('.biscuits-bundle-item__details').appendChild(extraDetails);
    }
  });
});

//When Biscuits module is loaded
document.addEventListener('BiscuitsBundleForm:ready', () => {
    const productOptionsDiv = document.querySelector('.biscuit-bundle-product');
    const isMixMatch = productOptionsDiv.classList.contains('mix-match-product');
    const isClassicBundle = productOptionsDiv.classList.contains('classic-bundle-product');
    
    // If product is a Classic or Mix and Match Bag
    if (isMixMatch || isClassicBundle) {
       // toggleStepProducts();
        toogleStepIndividualBags();
    }

    
    preventStepAccordionFromClosing(1);
    
});

//Update slider settings < code from Biscuits
//https://swiperjs.com/swiper-api#parameters
window.BiscuitsBundle.customSliderSettings = {
         mousewheel: { 
            forceToAxis: true, 
            sensitivity: 1, 
            releaseOnEdges: true, 
        }, 

        freeMode: {
            enabled: true,
            sticky: true,
            momentumVelocityRatio: 1
        },
        
        lazyPreloadPrevNext: 4,

        simulateTouch: true,
         grabCursor: true, 
         touchRatio: 1,
         touchStartPreventDefault: false, 
        
};

//Prevent 1st Step Closing
function preventStepAccordionFromClosing(stepNumber) {
  const step = document.querySelector(`biscuits-bundle-step[data-biscuits-step="${stepNumber}"]`);
  if (!step) return;

  const originalCloseAccordion = step.closeAccordion;
  const originalCheckForStepComplete = step.checkForStepComplete;

  step.classList.add('no-accordion');
  step.closeAccordion = function() {};

  step.checkForStepComplete = function() {
    const result = originalCheckForStepComplete.call(this);
    
    if (this.accordion.collapseOnComplete && this.accordion.enabled && this.errors.length === 0) {
      const stepDetails = this.stepRules;
      
      if (stepDetails.quantity_type != 'f') {
        if (this.minQuantityExceeded && !this.hasMaxQuantity) {
          return;
        }
        if (this.hasMaxQuantity) {
          if (this.maxQuantityReached) {}
        } else if (this.minQuantityReached) {}
      } else {
        if (this.minSelectedExceeded && !this.hasMaxSelectable) {
          return;
        }
        if (this.hasMaxSelectable) {
          if (this.maxSelectedReached) {}
        } else if (this.minSelectedReached) {}
      }
    }
    
    return result;
  };
}


//Show and Hide labels step based on bags in groups
function toggleStepProducts(){
    const bagStep = document.querySelector('[data-biscuits-step="'+ 2+'"');
    const labelStep = document.querySelector('[data-biscuits-step="'+ 3+'"');

    const bagProductItems = bagStep.querySelectorAll('.biscuits-bundle-item');
    const labelProductItems = labelStep.querySelectorAll('.biscuits-bundle-item');

    bagProductItems.forEach(function(productItem, index){
        productItem.addEventListener('biscuits--product-selection', function(event){
            if (event.detail.active){
                //If its the 2nd product hide/show step 3 
                const isSecondProduct = index === 1;
                labelStep.classList.toggle('show-labels', isSecondProduct);
                labelStep.classList.toggle('interacted', !isSecondProduct);

                //Deselect all labels
                if(!isSecondProduct) {
                    labelProductItems.forEach(function(productItem, index){
                        let alreadySelectedItems = labelStep.querySelectorAll('.biscuits-bundle-item.biscuits--active');
                        alreadySelectedItems.forEach(function(selectedItem){
                            if (selectedItem != productItem){
                            selectedItem.click();
                            }
                        });
                    });
                }
                
            }
        });
    });
}

//Show and Hide labels step based on individual bags
function toogleStepIndividualBags () {
    const bagStep = document.querySelector('[data-biscuits-step="'+ 2+'"');
    const labelStep = document.querySelector('[data-biscuits-step="'+ 3+'"');

    let plainBags = [
        54865789813114, //red
        54865795219834, //orange
        54865795252602, //yellow
        54865795285370, //green
        54865795318138, //lime
        54869280260474, //blue
        54865795350906, //sky
        54865795383674, //light blue
        54865795514746, //black
        54865795547514, //white
        54865795580282, //gold
        54945005764986 //rainbow
    ];

    const bagProductItems = bagStep.querySelectorAll('.biscuits-bundle-item');
    const labelProductItems = labelStep.querySelectorAll('.biscuits-bundle-item');

    bagProductItems.forEach(function(productItem, index){
        const bagId = Number(productItem.getAttribute('data-biscuits-id'));
        productItem.addEventListener('biscuits--product-selection', function(event){
            if (event.detail.active){

                const isPlain = plainBags.includes(bagId);
                labelStep.classList.toggle('show-labels', isPlain);
                labelStep.classList.toggle('interacted', !isPlain);

               
                if(!isPlain) {
                    labelProductItems.forEach(function(productItem, index){
                        let alreadySelectedItems = labelStep.querySelectorAll('.biscuits-bundle-item.biscuits--active');
                        alreadySelectedItems.forEach(function(selectedItem){
                            if (selectedItem != productItem){
                            selectedItem.click();
                            }
                        });
                    });
                }
                
            }
        });
    });   
}